<template>
	<section>
		<div class="back_lay" v-if="isUserModal" @click="closeModal"></div>

		<div class="modal modal_shadow" v-if="isUserModal">

			<!-- Outer -->
			<div class="modal__outer">
				<!-- Enter Inner -->
				<div class="modal__inner">

					<form id="entry_form" class="enter-form registration__form" @submit.prevent="addUser(user, isExist)">
						<p class="enter__text">Создание нового пациента</p>

						<!-- Enter Label -->
						<label class="enter__label" for="phone">Телефон
							<input-phone :user="user" class="enter-text-field enter-text-field_margin_n" id="phone"
													 v-model="user" :search="searchUser"></input-phone>
						</label>
						<!-- Enter Label End -->

						<!-- Enter Label -->
						<label class="enter__label" for="last_name">Фамилия
							<input class="enter-text-field enter-text-field_margin_n enter-text-field_capitalized" v-model="user.last_name" id="last_name"
										 type="text">
						</label>
						<!-- Enter Label End -->

						<!-- Enter Label -->
						<label class="enter__label" for="first_name">Имя
							<input class="enter-text-field enter-text-field_margin_n enter-text-field_capitalized" v-model="user.first_name" id="first_name"
										 type="text">
						</label>
						<!-- Enter Label End -->

						<!-- Enter Label -->
						<label class="enter__label" for="middle_name">Отчество
							<input class="enter-text-field enter-text-field_margin_n enter-text-field_capitalized" v-model="user.middle_name" id="middle_name"
										 type="text">
						</label>
						<!-- Enter Label End -->

						<div class="enter__btn-wrap enter__btn-wrap_flex">
							<input class="enter-form__button enter-form__button_gender"
										 :class="{'active_gb': user.sex === 'male'}"
										 @click="selectSex('male')" type="button" value="Муж">

							<input class="enter-form__button enter-form__button_gender"
										 :class="{'active_gb':user.sex === 'female'}"
										 @click="selectSex('female')" type="button" value="Жен">
						</div>

						<label class="enter__label" for="birthday">Дата рождения
							<input class="enter-text-field" v-model="user.birthday" v-mask="'##-##-####'" id="birthday" type="text"
										 placeholder="число-месяц-год">
						</label>

						<!-- Checkbox -->
						<div class="checkbox basic__checkbox">
							<label class="checkbox__label">
								<input class="checkbox__input" type="checkbox" value="adult" v-model="user.terms">
								<span class="checkbox__custom-input basic__checkbox-custom-input"></span>
								<span class="checkbox__text basic__checkbox-pad enter__checkbox-text">"Создавая нового пользователя, вы подтверждаете, что ознакомили его и он согласился с <router-link
									to="/agreement" class="checkbox__link" target="_blank">Пользовательским соглашением</router-link> сервиса Скраймед для оказания ему медицинских услуг"</span>
							</label>
						</div>
						<!-- Checkbox End -->

						<input class="enter-form__button" type="submit" value="Добавить">

					</form>
				</div>
				<!-- Enter Inner End -->
			</div>
			<!-- Outer End -->

			<i class="modal__icon_close icon ion-close trans" @click="closeModal"></i>
		</div>

	</section>
</template>

<script>
	import InputPhone from '@/components/InputPhone.vue';
	import moment from 'moment';

	export default {
		name: 'ClientModal',
		components: {InputPhone},
		computed: {
			clinicId() {
				return this.$route.query.clinic
			}
		},
		mounted() {
			this.$event.connect('openClientModal', (user, type) => {
				this.isUserModal = true
				this.userType = type

				if(user._id) {
					this.user = user;
					this.isExist = true;
				} else {
					this.user = {
						phone: '',
						birthday: '',
						sex: 'male',
					};
				}
                this.user.terms = true;
			});

			this.$event.connect('closeClientModal', () => this.closeModal());
		},
		beforeDestroy() {
			this.$event.disconnect(['openClientModal', 'closeClientModal'])
		},
		data() {
			return {
				isUserModal: false,
				user: {
					phone: '',
					birthday: '01-01-1960',
					sex: 'male'
				},
				isExist: false,
				userType: '',
				isStaff: false
			}
		},
		methods: {
			addUser(user, isExist) {
				if(!user.terms && !isExist) {
					this.$event.toast('e', 'Подтвердите соглашение')
					return false
				}

				if(isExist) {
					this.redirect(user, this.userType)
				} else {
					this.createUser(user, this.userType)
				}
			},
			createUser(user, type) {
				user.role = 'client';
				user.status = 'created';
				if(user.last_name) {
					user.last_name = this.capitalizeFirstLetter(user.last_name);
				}
				if(user.first_name) {
					user.first_name = this.capitalizeFirstLetter(user.first_name);
				}
				if(user.middle_name) {
					user.middle_name = this.capitalizeFirstLetter(user.middle_name);
				}
				if (!user.birthday) {
					user.birthday = '01-01-1960';
					console.log(user.birthday);
				}
				user.birthday = moment(user.birthday, 'DD-MM-YYYY').format('X');

				this.$api.post('user/', user)
					.then(response => this.redirect(response, type))
					.catch(error => this.$event.toast('e', error.data.errors))
			},
			redirect(user, type) {
				switch (type) {
					case "patient":
						return this.addPatient(user);
					case "agenda":
						return this.sendResponse(user);
				}
			},
			addPatient(user) {
				this.$api.get('worker/create-client/' + user._id + '/' + this.clinicId)
					.then(response => this.sendResponse(response))
			},
			sendResponse(user) {
				this.$event.send('userModalResponse', user)
				this.closeModal()
			},
			selectSex(sex) {
				this.user.sex = sex
			},
			searchUser(phone) {
				this.isExist = false
				if(phone.length < 12) {
					return false;
				}

				this.$api.get('user/by-phone/' + phone)
					.then(response => {
						if(response._id) {
							this.user = response
							this.user.birthday = moment(this.user.birthday, 'X').format('DD-MM-YYYY')
						} else {
							this.user = {
								phone: phone,
								birthday: '',
								sex: 'male',
							}
						}
                        this.user.terms = true;
						this.isExist = Boolean(response._id)
					})
			},

			closeModal() {
				this.isUserModal = false
				this.isExist = false

				this.user = {
					phone: '',
					birthday: '',
					sex: 'male',
				}
			},
			capitalizeFirstLetter(string) {
				return string[0].toUpperCase() + string.slice(1);
			}
		}
	}
</script>

<style scoped>
	.modal {
		z-index: 510;
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		background: white;
	}

	.enter-form {
		background-color: #fff;
		padding: 20px;
		border-radius: 2px;
	}

	.enter-text-field_capitalized {
		text-transform: capitalize;
	}

	.modal__outer {
		padding: 0;
	}

	.modal__inner:last-child {
		margin-bottom: 0;
	}

	.active_gb {
		background-color: #0F2142;
	}
</style>



// WEBPACK FOOTER //
// ClientModal.vue?27205b64